import {call, put, takeLatest,} from "@redux-saga/core/effects";
import * as Services from "../../Services/";
import {AddressActions} from './Slice';
import {DELETE_ADDRESS, GET_ADDRESSES, ISearchAddressParams, SAVE_ADDRESS} from "./Types"
import {PayloadAction} from "@reduxjs/toolkit";
import {setLoadingPending, setLoadingRejected, setLoadingResolve, toast} from "../../Utils/Utils";
import {LOADING_ADDRESSES, LOADING_SAVE_ADDRESS} from "../Loading/Types";
import {ADDRESS_MODAL} from "../Modal/Types";
import {ModalActions} from "../Modal/Slice";

function* getAddress(action?: PayloadAction<ISearchAddressParams>) {
  try {
    yield put(setLoadingPending(LOADING_ADDRESSES));
    const res = yield call(Services.getAddresses, action?.payload);
    yield put(setLoadingResolve(LOADING_ADDRESSES));
    if (!res?.results) {
      throw Error('There was an error.');
    } else {
      const cities: any = res.fetched_results.city;
      const zones: any = res.fetched_results.zone;

      const addresses = res.results.map((a: any) => {
        a.city = cities[a.city];
        if (zones[a.zone]) a.zone = zones[a.zone];
        return a;
      });

      yield put(AddressActions.setAddresses(addresses));
    }
  } catch (e) {
    toast("There was an error, please try again.", "error");
    console.error(e);
    yield put(setLoadingRejected(LOADING_ADDRESSES, e.message));
  }
}

function* deleteAddress({ payload }: any ) {
  try {
    const res = yield call(Services.deleteAddress, payload);
    if (!res?.success) {
      throw Error('There was an error.');
    } else {
      yield call(getAddress, { payload: { customer: payload.customer } } as PayloadAction<ISearchAddressParams> );
    }
  } catch (e) {
    toast("There was an error, please try again.", "error");
    console.error(e);
  }
}

function* saveAddress({ payload }: any ) {
  try {
    yield put(setLoadingPending(LOADING_SAVE_ADDRESS))
    const res = yield call(Services.saveAddress, payload);
    yield put(setLoadingResolve(LOADING_SAVE_ADDRESS))
    if (!res?.success) {
      throw Error('There was an error.');
    } else {
      const address = { ...payload }
      if (res.keys) address._KEY = res.keys[0];
      yield put(ModalActions.closeModal({
        modal: ADDRESS_MODAL,
        result: address
      }));
      yield call(getAddress, { payload: { customer: payload.customer } } as PayloadAction<ISearchAddressParams> );
    }
  } catch (e) {
    toast("There was an error, please try again.", "error");
    console.error(e);
    yield put(setLoadingRejected(LOADING_SAVE_ADDRESS, e.message))
  }
}


export function* addressSaga() {
  yield takeLatest(GET_ADDRESSES, getAddress);
  yield takeLatest(DELETE_ADDRESS, deleteAddress);
  yield takeLatest(SAVE_ADDRESS, saveAddress);
}
